import { defineComponent as _defineComponent } from 'vue'
import { useCustomerStore } from '@/store/customer';
    import i18n from '@/i18n';
    import { onMounted, ref } from 'vue';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'OfferInfoModal',
  setup(__props) {

    const customerStore = useCustomerStore();

    const isLoading = ref(true);

    onMounted(() => {
        setTimeout(() => {
            isLoading.value = false;
        }, 2 * 1000);
    });

return { __sfc: true,customerStore, isLoading, i18n }
}

})